export default __webpack_public_path__ + "static/media/logo.905a8aaa.png";